import type {AxiosResponse, RawAxiosRequestHeaders} from 'axios';
import axios from 'axios';
import {FirebaseUser} from '@local/logics/firebase/user';

// baseURLにapi入れて毎回 ID token セットするだけ
export const api = {
  get: async <T = unknown>(...arg: Parameters<typeof axios.get>): Promise<AxiosResponse<T>> => {
    return (await getAxios()).get(...arg);
  },
  post: async <T = unknown>(...arg: Parameters<typeof axios.post>): Promise<AxiosResponse<T>> => {
    return (await getAxios()).post(...arg);
  },
  delete: async <T = unknown>(...arg: Parameters<typeof axios.delete>): Promise<AxiosResponse<T>> => {
    return (await getAxios()).delete(...arg);
  },
  put: async <T = unknown>(...arg: Parameters<typeof axios.put>): Promise<AxiosResponse<T>> => {
    return (await getAxios()).put(...arg);
  },
  patch: async <T = unknown>(...arg: Parameters<typeof axios.patch>): Promise<AxiosResponse<T>> => {
    return (await getAxios()).patch(...arg);
  },
};

const getAxios = async () => {
  const headers: RawAxiosRequestHeaders = {
    'Content-Type': 'application/json',
  };
  if (FirebaseUser.user) {
    const idToken = await FirebaseUser.user.getIdToken();
    headers.Authorization = `Bearer ${idToken}`;
  }
  return axios.create({
    baseURL: '/api',
    headers,
  });
};
